import { lazy } from 'react'

export const BranchLazy = lazy(() => import('./Branch'))
